import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function RemoteWork() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  const [remoteWorkOptions, setRemoteWorkOptions] = useState([]);

  useEffect(
    () =>
      CommonService.getRemoteWorkOptions().then((data) =>
        setRemoteWorkOptions(data)
      ),
    []
  );
  
  return (
    <fieldset>
      <legend>{t("Remote Work")}</legend>
      <select
        className="form-select"
        value={searchObject.remoteWorkId || ""}
        name="remoteWorkId"
        onChange={onChange}
      >
        <option value=""></option>
        {remoteWorkOptions &&
          remoteWorkOptions.map((remote) => (
            <option key={remote.id} value={remote.id}>
              {t(remote.description)}
            </option>
          ))}
      </select>
    </fieldset>
  );
}
